export default "__VITE_ASSET__Dqn585kg__"